module.exports = __webpack_public_path__ + "img/8e7f94c3be9dad3316b768255f7d2084.png";